var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { observer } from 'mobx-react';
import { Draggable } from 'react-beautiful-dnd';
import { SortableItemPortalAware } from './SortableItemPortalAware';
let SortableItem_ = class SortableItem_ extends React.PureComponent {
    render() {
        const { sortableItem, itemIndex } = this.props;
        return (React.createElement(Draggable, { draggableId: sortableItem.id_string, index: itemIndex, type: sortableItem.question.id_string }, (provided, snapshot) => (React.createElement(SortableItemPortalAware, { provided: provided, snapshot: snapshot, sortableItem: sortableItem }))));
    }
};
SortableItem_ = __decorate([
    observer
], SortableItem_);
export { SortableItem_ };
